export const formatFloatWithCommasAndDecimals = (
  value: string | number | null,
  precision?: number,
  isDecimalsForced?: boolean,
  prefix?: string,
  suffix?: string,
  isOnlyFloatsHaveDecimals?: boolean
) => {
  if (typeof value !== 'number' && typeof value !== 'string') {
    return '';
  }
  let minimumFractionDigits = 0;
  if (isOnlyFloatsHaveDecimals) {
    minimumFractionDigits = Number.isInteger(value) ? 0 : precision ?? 3;
  } else if (isDecimalsForced) {
    minimumFractionDigits = precision ?? 3;
  }
  const numberValue = typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;

  const formattedNumber = (+numberValue).toLocaleString('en', {
    minimumFractionDigits,
    maximumFractionDigits: precision // if precision is undefined, toLocaleString returns up to 3 decimal places
  });
  return `${prefix || ''}${formattedNumber}${suffix || ''}`;
};

export const formatMetricPrefix = (value: string, prefix?: string, suffix?: string) => {
  const number = Math.abs(Number(value));
  let formattedNumber = `${number}`;
  if (number >= 1.0e9) {
    formattedNumber = `${Math.round((number / 1.0e9) * 10) / 10}B`;
  } else if (number >= 1.0e6) {
    formattedNumber = `${Math.round((number / 1.0e6) * 10) / 10}M`;
  } else if (number >= 1.0e3) {
    formattedNumber = `${Math.round((number / 1.0e3) * 10) / 10}K`;
  }
  return `${prefix || ''}${formattedNumber}${suffix || ''}`;
};

export const formatYoutubeShortUrl = (url: string | null) => {
  if (url?.includes?.('youtube.com/shorts')) {
    return url.split('?')[0].replace('shorts/', 'watch?v=');
  }
  return url;
};

export const formatOnlyNumberValue = (input: string): string | null => {
  const ALLOWED_SPECIAL_CHARS = ['$', '%', ' ', ',', '\\-'];
  const REMOVED_SPECIAL_CHARS = ['$', '%', ' ', ','];
  const allowedCharsRegex = new RegExp(`[^0-9.${ALLOWED_SPECIAL_CHARS.join('')}]`);
  if (allowedCharsRegex.test(input)) {
    return null;
  }
  const removedCharsRegex = new RegExp(`[${REMOVED_SPECIAL_CHARS.join('')}]`, 'g');
  const cleanedString = input.replace(removedCharsRegex, '');

  const validFormatRegex = /^-?\d+(\.\d+)?$/;
  if (!validFormatRegex.test(cleanedString)) {
    return null;
  }
  const parts = cleanedString.split('.');
  return parts[0] + (parts.length > 1 ? `.${parts.slice(1).join('')}` : '');
};
